module.exports = __webpack_public_path__ + "media/dogs/dog-celebrating-f703769c.svg";